import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import "./assets/css/fonts.css";
import Products from "./pages/products/Products";
import Cashfree from "./pages/cashfree/CashFree";
import Paytm from "./pages/paytm-button/Paytm";
import PageNotFound from "./pages/404/PageNotFound";
import PhonePe from "./pages/phonepe/PhonePe";
import SuccessPage from "./pages/payment-result/PaymentResult";
import ProductDetails from "./pages/details-page/ProductDetails";
import { ThemeProvider } from "@mui/styles";
import { Alert, Grid, Snackbar, unstable_createMuiStrictModeTheme } from "@mui/material";
import NavBar from "./pages/NavBar/NavBar";
import SecrectSettlement from "./pages/settlement-page/SecrectSettlement";
import { environment } from "./constant";
import { setGlobalState } from "./globalStyle";
import ConfigLoader from "./components/Config/ConfigLoader";
const theme = unstable_createMuiStrictModeTheme({
  palette: {
    primary: {
      main: "#3f51b5",
      dark: "#252525",
      alto: "#cfcfcf",
      white: "#FFFFFF",
    },
    typography: {
      fontFamily: "Montserrat, sans-serif",
    },
  },
});

const App = () => {
  const [utmData, setUtmData] = useState({
    utm_source: null,
    utm_campaign: null,
    utm_adgroup: null,
    utm_medium: null,
    utm_adset: null,
    Ads: null,
    commSource: null,
    utm_content:null
  });

  const [queryParams, setQueryParams] = useState({});

  // Add dependencies related to URL parameters
  const urlSearchParams = new URLSearchParams(window.location.search);
  const isCustomFormat = window.location.search.includes("formattype=custom");

  const  env = environment;
  useEffect(() => {
    const urlParams = new URLSearchParams(urlSearchParams);
    const utmSource = urlParams.get('utm_source');
    const utmCompaign = urlParams.get('utm_campaign');
    const utmMedium = urlParams.get('utm_medium');
    const utmAddGroup = urlParams.get('utm_adgroup');
    const utmAdSet = urlParams.get('utm_adset');
    const utmAds = urlParams.get('utm_ads');
    const commSource = urlParams.get('commSource');
    const SourceContent = urlParams.get('utm_content');
    const referCode = urlParams.get('referCode') || urlParams.get('refer-code');

    const leadSquaredBody = {
      utm_source: utmSource,
      utm_campaign: utmCompaign,
      utm_adgroup: utmAddGroup,
      utm_medium: utmMedium,
      utm_adset: utmAdSet,
      Ads: utmAds,
      commSource: commSource,
      utm_content:SourceContent,
      referCode:referCode
    };
    setUtmData(leadSquaredBody);
   setGlobalState("leadSquaredDataVal", leadSquaredBody);
  }, []);

useEffect(() => {
  setQueryParams((prev) => ({
    ...prev,
    clientCodeQueryVal: urlSearchParams.get("clientCode"),
    mobileQueryVal: urlSearchParams.get("mobile"),
    client_emailQueryVal: urlSearchParams.get("client_email"),
    product_plan_idQueryVal: urlSearchParams.get("product_plan_id"),
    return_urlQueryVal: urlSearchParams.get("return_url"),
    paymentMethodQueryVal: urlSearchParams.get("paymentMethod"),
    paymentGatewayQueryVal: urlSearchParams.get("paymentGateway"),
    gstQueryVal: urlSearchParams.get("gst"),
    first_nameQueryVal: urlSearchParams.get("name"),
    lastNameQueryVal: urlSearchParams.get("last_name"),
    cityQueryVal: urlSearchParams.get("city"),
    stateQueryVal: urlSearchParams.get("state"),
    pincodeQueryVal: urlSearchParams.get("pincode"),
    addressQueryVal: urlSearchParams.get("address"),
    panCodeQueryVal: urlSearchParams.get("planCode"),
    planQueryVal: urlSearchParams.get("plan"),
    addressQueryVal: urlSearchParams.get("address"),
    secretPlansQueryVal: urlSearchParams.get("splans"),
    productCodeQueryVal: urlSearchParams.get("productCode"),
    hidebottomsheetQueryVal: urlSearchParams.get("hidebottomsheet"),
    envQueryVal: urlSearchParams.get("env"),
    referCode: urlSearchParams.get("referCode") || urlSearchParams.get("refer-code")
  }));
},[])

  return (
    <div className={isCustomFormat ? "background" : ""}>
      <ThemeProvider theme={theme}>
        {!isCustomFormat ? <NavBar /> : null}
        <BrowserRouter>
          <Routes>

            <Route path="/" element={<Products formattype={isCustomFormat ? "custom" : ""} queryStringData={queryParams} utmQueryData = {utmData}/>} />
            <Route path="/details" element={<ProductDetails formattype={isCustomFormat ? "custom" : ""} leadSquaredData={utmData} />} />
            <Route path="/settlement" element={<SecrectSettlement formattype={isCustomFormat ? "custom" : ""} leadSquaredData={utmData} />} />
            <Route path="/paytm" element={<Paytm formattype={isCustomFormat ? "custom" : ""} leadBody={utmData} />} />
            <Route path="/phonepe" element={<PhonePe />} />
            <Route path="/cashfree" element={<Cashfree />} />
            <Route path="/payment/:method/:gateway/:id" element={<SuccessPage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </BrowserRouter>
        {env && (
          <Grid container >
            {env === 'dev' && (
              <Grid item xs={12} sm={6} md={4}>
                <Snackbar
                  open={true}
                  autoHideDuration={3000} // Adjust this value to set the desired duration
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <Alert severity="warning" sx={{ fontSize: '18px', marginTop: '25%' }}>
                    You are in UAT!
                  </Alert>
                </Snackbar>
              </Grid>
            )}
          </Grid>
        )}
      </ThemeProvider>
    </div>
  );
};

export default App;
